<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_3" title="Title Page">BIRMINGHAM REVOLUTION</h2>
<h2 class="sigil_not_in_toc"><span class="small-caps">Martin Luther King Jr.’s<br/>
  Epic Challenge to the Church</span></h2>
<div class="photo"><img alt="3769_TP.psd" class="photo" src="Images/3769_TP.jpg"/></div>
<h3 class="sigil_not_in_toc">Edward Gilbreath</h3>
<p class="center"><br/></p>
<h3 class="sigil_not_in_toc"><span class="sgc-2"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></span><br/></h3>
<p class="center"><a href="http://www.IVPress.com/books/" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?70c36730